import { render, staticRenderFns } from "./UnorderedListItem.vue?vue&type=template&id=0c8e22cc&scoped=true"
import script from "./UnorderedListItem.vue?vue&type=script&lang=js"
export * from "./UnorderedListItem.vue?vue&type=script&lang=js"
import style0 from "./UnorderedListItem.vue?vue&type=style&index=0&id=0c8e22cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e22cc",
  null
  
)

export default component.exports